import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { TimeZonesEnum } from '@ep/shared';

interface TimezoneOption {
  value: TimeZonesEnum;
  label: string;
}

@Component({
  selector: 'app-us-timezone-dropdown',
  standalone: true,
  imports: [CommonModule, FormsModule, DropdownModule],
  templateUrl: './us-timezone-dropdown.component.html',
  styleUrls: ['./us-timezone-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UsTimezoneDropdownComponent),
      multi: true,
    },
  ],
})
export class UsTimezoneDropdownComponent implements OnInit, ControlValueAccessor {
  @Input() label: string = 'Timezone';
  @Input() placeholder: string = 'Select a timezone';
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() styleClass: string = '';
  @Input() showClear: boolean = false;

  value: TimeZonesEnum | null = null;
  timezones: TimezoneOption[] = [];
  isDisabled: boolean = false;

  // ControlValueAccessor methods
  private onChange = (value: TimeZonesEnum | null) => {};
  private onTouched = () => {};

  ngOnInit() {
    this.initializeTimezones();
  }

  initializeTimezones() {
    // Only include US timezones
    this.timezones = [
      { value: TimeZonesEnum.PACIFICTIME, label: '(GMT-08:00) Pacific Time' },
      { value: TimeZonesEnum.MOUNTAINTIME, label: '(GMT-07:00) Mountain Time' },
      { value: TimeZonesEnum.CENTRALTIME, label: '(GMT-06:00) Central Time' },
      { value: TimeZonesEnum.EASTERNTIME, label: '(GMT-05:00) Eastern Time' },
    ];
  }

  onSelectionChange(event: any) {
    this.value = event.value;
    this.onChange(this.value);
    this.onTouched();
  }

  // ControlValueAccessor interface methods
  writeValue(value: TimeZonesEnum | null): void {
    if (value !== undefined) {
      this.value = value;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
}
